export const ENTITY_NAME = Symbol('__ENTITY_NAME__');
export const FILE_SYNC = Symbol('__FILE_SYNC__');
